module.exports = __webpack_public_path__ + "img/yt-cdai_usdc.c204cf92.png";